// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"455":"f2f8e7ea","977":"83c9f010"}[chunkId] + ".chunk.js");